/**
 * Store Mutation types
 */
// APP
// Activity Related
export const APP_STATE_CLEARED = 'app.STATE_CLEARED';
export const ACTIVITY_ADDED = 'app.ACTIVITY_ADDED';
export const ACTIVITY_CLEARED = 'app.ACTIVITY_CLEARED';
export const SESSION_COUNT_ADDED = 'app.SESSION_COUNT_ADDED';
export const SESSION_COUNT_CLEARED = 'app.SESSION_COUNT_CLEARED';
export const ERROR_FLASH_ADDED = 'app.ERROR_FLASH_ADDED';
export const ERROR_FLASH_CLEARED = 'app.ERROR_FLASH_CLEARED';
export const CONTENT_LOADING = 'app.CONTENT_LOADING';
export const CONTENT_LOADED = 'app.CONTENT_LOADED';
export const APP_MODE_SET = 'app.APP_MODE_SET';



// WEBPACK FOOTER //
// ./src/store/mutations/app.js